import type { ConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type GivingsRequestParams = paths['/v3/givings']['get']['parameters']['query'];
type ResponseType = paths['/v3/givings']['get']['responses']['200']['content']['application/json'];

export const getGivings = async ({ config: { params } }: ConfigRequest<GivingsRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.givings.find, {
    params,
  });
